const config = require('../temp/config');

const isDisconnected = /localhost/i.test(config.sitecoreApiHost);
module.exports = {
  isDisconnected,
};
